import { defineStore } from 'pinia'
import { ref } from 'vue'
import * as CmsService from '@/services/cms.service'
import type { Page } from '@/models/Page'
import { getSinglePage } from '@/services/cms.service'


import fallbackImage from '@/assets/logo_luxury_yachts_red.png';

export const useSinglePageStore = defineStore('singlePage', () => {
    const page = ref<Page | null>(null)
    const loading = ref(false)

    async function fetchPage(slug: string) {
        loading.value = true
        try {
            const { data } = await CmsService.getSinglePage(slug)
            console.log("Data: ", data)
            // Assign default image if not available
            if (!data.heroImage || !data.heroImage.full) {
                data.heroImage = {
                    full: fallbackImage // adjust the path if needed
                }

            }
            page.value = data
        } catch (e) {
            page.value = null
            console.error('Failed to load page:', e)
        } finally {
            loading.value = false
        }
    }

    return { page, loading, fetchPage }
})
